import React, {useState} from 'react';
import {useSelector} from "react-redux";
import {selectCurrentUser} from "../../../../features/authentication/authenticationSelectors";
import {useTranslation} from "react-i18next";
import {Query} from "@syncfusion/ej2-data";
import GridTab from "../../../ui/components/Grid/GridTab/GridTab";
import GridTabSection, {GridTabSectionType} from "../../../ui/components/Grid/GridTab/GridTabSection/GridTabSection";
import PermissionType from "../../../../data/enums/PermissionType";
import GridTabItem from "../../../ui/components/Grid/GridTab/GridTabItem/GridTabItem";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAdd, faRefresh} from "@fortawesome/free-solid-svg-icons";
import {ColumnDirective, ColumnsDirective, Filter, Inject, Page, Sort} from "@syncfusion/ej2-react-grids";
import PostSourceStateFilter from "./filters/PostSourceStateFilter";
import PostSourceCategoryFilter from "./filters/PostSourceCategoryFilter";
import GridComponent from "../../../ui/components/Grid/GridComponent";
import Loader from "../../../ui/components/Loader/Loader";
import {useNavigate} from "react-router-dom";
import PostSourceTypeFilter from "./filters/PostSourceTypeFilter";

const PostSource = () => {
    const user = useSelector(selectCurrentUser);
    const [query] = useState(new Query());
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [filterTrigger, setFilterTrigger] = useState(null);
    const {t} = useTranslation();
    const navigate = useNavigate();

    const stateFilter = (props) => <PostSourceStateFilter filterStoreEntityName={'source'}
                                                          onFilterChange={(ev, fieldName) => setFilterTrigger({
                                                              ev,
                                                              fieldName
                                                          })} {...props} />;
    const categoryFilter = (props) => <PostSourceCategoryFilter filterStoreEntityName={'source'}
                                                                onFilterChange={(ev, fieldName) => setFilterTrigger({
                                                                    ev,
                                                                    fieldName
                                                                })} {...props}/>;
    const postSourceTypeFilter = (props) => <PostSourceTypeFilter filterStoreEntityName={'source'}
                                                                  onFilterChange={(ev, fieldName) => setFilterTrigger({
                                                                      ev,
                                                                      fieldName
                                                                  })} {...props}/>;

    const onTabItemClick = ({id}) => {
        if (id) {
            if (id === 'refresh-btn') {
                setRefreshTrigger(prev => prev + 1);
            }

            if (id === 'add-btn') {
                navigate(`/news/sources/source/`);
            }
        }
    }

    const onRowDoubleClick = ev => {
        if (ev && ev.rowData) {
            navigate(`/news/sources/source/${ev.rowData.id}`);
        }
    }

    return (
        <div className='list-container'>
            <GridTab onClick={onTabItemClick}>
                <GridTabSection type={GridTabSectionType.Button}>
                    {user.permission.newsSources === PermissionType.Editing
                        ? (
                            <GridTabItem id='add-btn'
                                         text={t("btn.add")}
                                         icon={<FontAwesomeIcon icon={faAdd}/>}>

                            </GridTabItem>
                        )
                        : null
                    }
                    <GridTabItem id='refresh-btn'
                                 text={t("btn.refresh")}
                                 icon={<FontAwesomeIcon icon={faRefresh}/>}>

                    </GridTabItem>
                </GridTabSection>
            </GridTab>
            {!query
                ? <Loader/>
                : <GridComponent id='grid'
                                 container='.list-container'
                                 url='/api/postSource/getPostSources'
                                 query={query}
                                 refresh={refreshTrigger}
                                 filterStoreEntityName={'source'}
                                 onRowClick={onRowDoubleClick}
                                 filter={filterTrigger}>
                    <ColumnsDirective>
                        <ColumnDirective field='id'
                                         visible={false}
                                         textAlign="center"
                                         isPrimaryKey={true}
                                         type='number'/>
                        <ColumnDirective field='name'
                                         headerText={t("postSource.grid.name")}
                                         width='200'
                                         textAlign="center"/>
                        <ColumnDirective field='category'
                                         headerText={t("postSource.grid.category")}
                                         width='150'
                                         textAlign="center"
                                         allowSorting={false}
                                         filterTemplate={categoryFilter}/>
                        <ColumnDirective field='type'
                                         headerText={t("postSource.grid.type")}
                                         width='150'
                                         textAlign="center"
                                         allowSorting={false}
                                         filterTemplate={postSourceTypeFilter}/>
                        <ColumnDirective field='isBlocked'
                                         headerText={t("postSource.grid.blocked")}
                                         width='150'
                                         displayAsCheckBox={true}
                                         textAlign="center"
                                         filterTemplate={stateFilter}/>
                    </ColumnsDirective>
                    <Inject services={[Page, Sort, Filter]}/>
                </GridComponent>
            }
        </div>
    )
}

export default PostSource;